module.exports = __webpack_public_path__ + "img/20230418093202.a0dfe3d3.png";